function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterFilterOutlet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2754",
    d: "M16.034 0H16a15.983 15.983 0 1 0 .034 0M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14",
    style: {
      fill: "#ff7600"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2755",
    d: "M13.3 13.9a2.7 2.7 0 0 0 5.4 0c0-1.457-2.7-5.2-2.7-5.2s-2.7 3.746-2.7 5.2m3.9-.874a.728.728 0 0 1 .686.666.686.686 0 1 1-.686-.666m7.379 9.458v1H7.42v-1h7.412v-2.443A7.456 7.456 0 1 1 20.809 7.1l2.048-1.526-.621 4.249-4.25-.62 2-1.489A6.4 6.4 0 1 0 22.2 11.3l.977-.213a7.438 7.438 0 0 1-6.346 8.969v2.426zM7.42 24.468h17.159v1H7.42z",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFilterOutlet);
export default __webpack_public_path__ + "static/media/water-filter-outlet.584bd886ab67f0ea96cf6fa39b9106cf.svg";
export { ForwardRef as ReactComponent };